import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { hasAnySim, isAllNao } from '../../utils-consultaSeguimento'
import { isStatusValid } from '../../validator-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta08ForaAlcanceEnum,
  ConsultaSeguimentoPergunta08Model,
} from './model-consultaSeguimentoPergunta08'

export const validatorConsultaSeguimentoPergunta08 = createValidator<ConsultaSeguimentoPergunta08Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_08_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta08Model, errors: ErrorObject<ConsultaSeguimentoPergunta08Model>) => {
    if (values?.PERGUNTA_08_HEADER === SimNaoEnum.SIM) {
      errors.PERGUNTA_08_SE_INTERESSA_POR = required(values?.PERGUNTA_08_SE_INTERESSA_POR)
    }
    if (
      values?.PERGUNTA_08_HEADER === SimNaoEnum.NAO ||
      (values?.PERGUNTA_08_HEADER === SimNaoEnum.SIM &&
        values?.PERGUNTA_08_SE_INTERESSA_POR &&
        values?.PERGUNTA_08_SE_INTERESSA_POR !== SimNaoEnum.SIM)
    ) {
      errors.PERGUNTA_08_RESPONDE_PERGUNTAS = required(values?.PERGUNTA_08_RESPONDE_PERGUNTAS)
      if (values?.PERGUNTA_08_RESPONDE_PERGUNTAS === SimNaoEnum.SIM) {
        if (hasAnySim(values?.PERGUNTA_08_FORA_ALCANCE)) {
          errors.PERGUNTA_08_RESPONDE_CRIANCAS = required(values?.PERGUNTA_08_RESPONDE_CRIANCAS)
        } else if (
          !isAllNao(values?.PERGUNTA_08_FORA_ALCANCE, Object.values(ConsultaSeguimentoPergunta08ForaAlcanceEnum))
        ) {
          errors.PERGUNTA_08_FORA_ALCANCE = 'Deve responder sim para algum ou não para todos'
        }
      }
    }
    return errors
  }
)
